/**
 * Segment of a ``FilterGroup`` in list-page toolbars. Click toggles
 * active state and bubbles via ``onClick``.
 */
import { type ReactNode } from "react";
import { cn } from "@/lib/utils";

export function FilterChip({
  active,
  children,
  onClick,
}: {
  active: boolean;
  children: ReactNode;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      data-state={active ? "active" : "inactive"}
      className={cn(
        "inline-flex h-7 items-center rounded-md px-3 text-xs font-medium capitalize transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
        active
          ? "bg-primary/10 text-primary"
          : "text-muted-foreground hover:text-foreground",
      )}
    >
      {children}
    </button>
  );
}
